import { GenericCrudPage } from '@/components/GenericCrudPage';
import { proctorConfig } from '@/pages/configs';

export default function ProctorPage() {
  return <GenericCrudPage config={proctorConfig} />;
}
